import axios from 'axios'
import React, { useEffect, useState } from 'react'
import authService from '../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2
} from '../../../Components/Main'
import ProfileDireita from '../../../Components/ProfileDireita'
import { NavDireita } from '../../../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../../../Components/SideBar-right/SidebarMobile'
import '../../../styles/pages/SubMenuPages/SubMenuFuncaoEPermissao/SubMenuFuncaoEPermissao.css'
import ModalClassificacao from '../../MenuDireito/MenuDireito-Modal/ModalCadClassificacao'
import ModalEditar from '../../MenuDireito/MenuDireito-Modal/ModalEdiClassificacao'

function SubMenuClassificacao() {
  var user = authService.getCurrentUser()
  const [Classificao, setClassificao] = useState<any[]>([])
  const [modalOpen, setModalOpen] = useState(false)
  const [modalInfo, setModalInfo] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/classificacao/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setClassificao(response.data)
      })
  }, [])
  return (
    <div className="displayInteract">
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" style={{ width: '200px', height: '80px' }} />
        </div>

        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>CADASTRO DE TIPOS DE CLASSIFICAÇÃO</TitlePage1>
            {/* <TitlePage2>Cadastro De Classificação</TitlePage2> */}
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />

            <ModalClassificacao />
          </div>
        </div>
        <div className="tabelaPadrao">
          {modalOpen && (
            <ModalEditar setOpenModal={setModalOpen} modalInfo={modalInfo} />
          )}
          <table>
            <thead>
              {/* <th>CÓD</th> */}
              <th>Descrição Da Classificação</th>
              <th>Observação</th>
              <th>Ativo</th>
            </thead>
            <tbody>
              {Classificao.filter(val => {
                if (searchTerm === '') {
                  return val
                } else if (
                  val.clsDescricao
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
                ) {
                  return val
                }
              }).map(classificacao => (
                <tr
                  onClick={() => handleToggleComplete(classificacao)}
                  key={classificacao.IdClassificacao}
                >
                  {/* <td>
                    <p className="Space1">{classificacao.IdClassificacao}</p>
                  </td> */}
                  <td>
                    <p className="Space1">{classificacao.clsDescricao}</p>
                  </td>
                  <td>
                    <p className="Space4">{classificacao.clsObservacoes}</p>
                  </td>
                  <td>
                    <label className="container">
                      <input
                        type="checkbox"
                        defaultChecked={!!classificacao.clsStatus}
                        disabled
                      />
                      <span className="checkmark"></span>
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <SidebarMobile />
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        {/* <NavDireita /> */}
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default SubMenuClassificacao
